import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Truck, ShieldCheck, Sparkles, WashingMachine, Star, BadgeCheck, Leaf } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ProductCard } from "@/components/ProductCard";
import api, { sortOffersFirst } from "@/lib/api";

const trust = [
  { icon: WashingMachine, title: "300+ spălări", desc: "Randament ridicat per pachet" },
  { icon: Sparkles, title: "Texturi fine/moi", desc: "Rufe catifelate la fiecare spălare" },
  { icon: ShieldCheck, title: "Curățenie garantată", desc: "Formule eficiente, testate" },
  { icon: Truck, title: "Transport GRATUIT", desc: "La toate comenzile, oriunde în țară" },
];

export default function Home() {
  const [featured, setFeatured] = useState([]);

  useEffect(() => {
    api.get("/products", { params: { featured: true } }).then(({ data }) => setFeatured(sortOffersFirst(data))).catch(() => {});
  }, []);

  return (
    <div data-testid="home-page">
      {/* PRODUCTS FIRST — vizibile direct la intrare */}
      <section className="mx-auto max-w-7xl px-4 pt-8 pb-12 sm:px-6 lg:px-8">
        <div className="mb-6 text-center">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-accent">Detergenți profesionali ClarWash</span>
          <h1 className="mt-2 font-heading text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            Produsele noastre
          </h1>
          <div className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-medium text-slate-600">
            <span className="flex items-center gap-1.5"><Star className="h-4 w-4 fill-yellow-400 text-yellow-400" /> 4.9/5 · 500+ recenzii</span>
            <span className="flex items-center gap-1.5"><BadgeCheck className="h-4 w-4 text-success" /> 2000+ comenzi livrate</span>
            <span className="flex items-center gap-1.5"><Truck className="h-4 w-4 text-success" /> Transport GRATUIT</span>
          </div>
        </div>

        {featured.length === 0 ? (
          <p className="text-center text-slate-500">Se încarcă produsele...</p>
        ) : (
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4">
            {featured.map((p, i) => (
              <ProductCard key={p.id} product={p} index={i} />
            ))}
          </div>
        )}
      </section>

      {/* HERO */}
      <section className="bubble-bg noise-overlay relative overflow-hidden">
        <div className="mx-auto max-w-3xl px-4 py-16 text-center sm:px-6 lg:py-24 lg:px-8">
          <div className="animate-fade-up text-white">
            <Badge className="mb-5 border-white/30 bg-white/15 text-white backdrop-blur hover:bg-white/25">
              <BadgeCheck className="mr-1 h-3.5 w-3.5" /> Curățenie garantată
            </Badge>
            <h2 className="font-heading text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
              Detergenți profesionali <span className="text-white/80">ClarWash</span>
            </h2>
            <p className="mx-auto mt-6 max-w-lg text-lg text-white/90">
              Rufe curate, parfumate și catifelate. Pachete generoase de 5L, până la 300 de spălări,
              cu transport gratuit și plată la livrare.
            </p>
            <div className="mt-8 flex items-center justify-center gap-6 text-sm text-white/80">
              <span className="flex items-center gap-2"><Truck className="h-4 w-4" /> Transport gratuit</span>
              <span className="flex items-center gap-2"><Leaf className="h-4 w-4" /> Parfum de lungă durată</span>
            </div>
          </div>
        </div>
      </section>

      {/* TRUST BAR moved below featured */}

      {/* TRUST BAR (sub Produse recomandate) */}
      <section className="border-y border-slate-200 bg-white">
        <div className="mx-auto grid max-w-7xl grid-cols-2 gap-6 px-4 py-10 sm:px-6 lg:grid-cols-4 lg:px-8">
          {trust.map((t) => (
            <div key={t.title} className="flex items-start gap-3" data-testid={`trust-${t.title}`}>
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
                <t.icon className="h-5 w-5" />
              </span>
              <div>
                <p className="font-heading text-sm font-bold text-slate-900">{t.title}</p>
                <p className="text-xs text-slate-500">{t.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* PROMO BANNER */}
      <section className="mx-auto max-w-7xl px-4 pb-16 sm:px-6 lg:px-8">
        <div className="noise-overlay overflow-hidden rounded-2xl bg-primary px-8 py-12 text-center text-white sm:px-16 sm:py-16">
          <h3 className="font-heading text-3xl font-extrabold tracking-tight sm:text-4xl">TRANSPORT GRATUIT</h3>
          <p className="mx-auto mt-3 max-w-xl text-white/85">
            La toate comenzile, oriunde în țară. Plătești comod la livrare, prin ramburs.
          </p>
          <Button asChild size="lg" className="mt-8 rounded-full bg-white text-primary hover:bg-white/90">
            <Link to="/magazin">Comandă acum</Link>
          </Button>
        </div>
      </section>
    </div>
  );
}
